import { NavigateFunction } from 'react-router-dom';
import { clearAuth, getAuthHeaders } from './auth';
import config from '../config';

interface FetchOptions extends RequestInit {
  params?: Record<string, string>;
}

// 自定义的 JSON 解析函数，用于保留大整数精度
const parseJsonWithBigInt = async (response: Response): Promise<any> => {
  // 获取响应文本
  const text = await response.text();
  
  // 使用正则表达式识别并处理大整数
  // 这个正则表达式匹配 JSON 中的数字（包括大整数）
  // 我们识别超过安全整数范围的数字并将其转为字符串
  const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER.toString().length - 1;
  
  // 处理带引号的键值对中的大整数，不处理已经是字符串的值
  const processedText = text.replace(/"(\w+)":\s*(\d{16,})(,|\}|\])/g, (match, key, value, suffix) => {
    // 如果数字长度超过安全范围，将其保留为字符串
    return `"${key}":"${value}"${suffix}`;
  });
  
  // 解析处理后的JSON
  try {
    return JSON.parse(processedText);
  } catch (e) {
    console.error('Error parsing JSON with bigint handling:', e);
    // 如果解析失败，尝试直接解析原始响应
    return JSON.parse(text);
  }
};

// 用于处理API响应的拦截器
export const handleApiResponse = async (response: Response, navigate: any): Promise<any> => {
  const data = await parseJsonWithBigInt(response);
  
  // 检查是否需要重新登录
  if (data.code === 2227) {
    clearAuth();
    navigate('/login');
    throw new Error('Login required');
  }
  
  return data;
};

export const fetchWithAuth = async (url: string, options: RequestInit = {}, navigate?: (path: string) => void) => {
  // 确保 headers 存在并合并，优先使用传入的 headers
  const headers = {
    ...getAuthHeaders(),  // 基础认证 headers
    ...options.headers,   // 自定义 headers 可能会覆盖基础 headers
  };

  // 更新 options 中的 headers
  options.headers = headers;

  try {
    const response = await fetch(url, options);
    
    if (response.status === 401) {
      // 清除认证信息
      clearAuth();
      
      // 如果提供了navigate函数，则重定向到登录页面
      if (navigate) {
        navigate('/login');
      }
      
      throw new Error('Login required');
    }
    
    // 使用自定义函数解析响应，处理大整数
    const data = await parseJsonWithBigInt(response);
    return data;
  } catch (error) {
    console.error('API request error:', error);
    throw error;
  }
}; 